import React, { useEffect, useState } from "react";
import { Fab, Badge } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const FloatingCartIcon = () => {
	const [cartCount, setCartCount] = useState(0);
	const [isCartPage, setIsCartPage] = useState(false);

	useEffect(() => {
		function updateCartCount() {
			const cart = JSON.parse(localStorage.getItem("cart") || "[]");
			setCartCount(cart.length);
		}
		updateCartCount();
		window.addEventListener("storage", updateCartCount);
		return () => window.removeEventListener("storage", updateCartCount);
	}, []);

	useEffect(() => {
		const checkCartPage = () => {
			setIsCartPage(window.location.pathname === "/cart");
		};
		checkCartPage();
		window.addEventListener("popstate", checkCartPage);
		window.addEventListener("pushstate", checkCartPage);
		window.addEventListener("replacestate", checkCartPage);
		return () => {
			window.removeEventListener("popstate", checkCartPage);
			window.removeEventListener("pushstate", checkCartPage);
			window.removeEventListener("replacestate", checkCartPage);
		};
	}, []);

	if (cartCount === 0 || isCartPage) return null;

	return (
		<Fab
			color="primary"
			aria-label="cart"
			sx={{
				position: "fixed",
				bottom: 24,
				right: 24,
				zIndex: 1300,
				boxShadow: 4,
			}}
			onClick={() => (window.location.href = "/cart")}
		>
			<Badge badgeContent={cartCount} color="secondary">
				<ShoppingCartIcon />
			</Badge>
		</Fab>
	);
};

export default FloatingCartIcon;
